// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"488":"axiom","532":"styles","592":"common","736":"vendor"}[chunkId] || chunkId) + "." + {"131":"6cbed2740d57fee78991","488":"9410e0e458c43874eca9","532":"59f8ba85c8915f291141","592":"540a187630423cb79047","736":"541f46682671a198246d"}[chunkId] + ".js";
};